import React, { useState, useEffect, useContext } from "react";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  TablePagination,
  CircularProgress,
  Grid,
  Container,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { ContextSession } from "../../services/ContextSession";
import { useMediaQuery } from "@mui/material";
import CryptoJS from "crypto-js"; // Importante: agregar para la firma

// Estilos personalizados para las celdas de la tabla
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#19438C",
    color: "white",
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

// Estilos personalizados para las filas de la tabla
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: "#C1C1C1",
  },
}));

const MisDatos = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const isMobile = useMediaQuery("(max-width:820px)");
  const sessi = useContext(ContextSession);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const useFront =
          "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8"; // Misma clave secreta
        const dni = sessi.sessionData.identidad;
        const usuario = sessi.sessionData.usuario; // Debes tener usuario en sessionData también
        const queryString = `identidad=${dni}`;
        const signature = CryptoJS.HmacSHA256(queryString, useFront).toString(
          CryptoJS.enc.Hex
        );

        const formData = new FormData();
        formData.append("identidad", dni);

        const response = await fetch(
          `${sessi.ip}/api/historial/instituciones/participante/`,
          {
            method: "POST",
            body: formData,
            headers: {
              Authorization: `Bearer ${sessi.sessionData.token}`,
              "X-Signature": signature, // Firma en el header
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error en la respuesta de la API");
        }

        const responseData = await response.json();

        if (responseData && responseData.length > 0) {
          setData(responseData);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error al consultar instituciones:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [sessi.sessionData.identidad]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Container style={{ marginTop: isMobile ? 1 : 50 }}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <h1>Instituciones Cotizadas</h1>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table>
          <caption style={{ textAlign: "justify" }}>
            Nota: Si considera que la información presentada anteriormente esta
            errónea, llame a nuestro Call Center +504 2290-1900 OPCIÓN #3
          </caption>
          <TableHead>
            <StyledTableRow>
              <StyledTableCell
                style={{
                  textAlign: "center",
                  fontSize: isMobile ? "12px" : "14px",
                }}
              >
                #
              </StyledTableCell>
              <StyledTableCell style={{ fontSize: isMobile ? "12px" : "14px" }}>
                Nombre de la Institución
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {error ? (
              <StyledTableRow>
                <StyledTableCell colSpan={2} align="center">
                  No se encontraron datos
                </StyledTableCell>
              </StyledTableRow>
            ) : (
              data.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell
                    style={{
                      textAlign: "center",
                      fontSize: isMobile ? "12px" : "14px",
                    }}
                  >
                    {index + 1}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{ fontSize: isMobile ? "12px" : "14px" }}
                  >
                    {row.institucion.trim()}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default MisDatos;
